import React from 'react';

const StyledSmParagraph=({children , fontColor})=>{
    return(
        <p className={`text-sm font-mulish ${fontColor}`}>{children}</p>
    );
}
export default StyledSmParagraph;